import React from 'react';
import { BaseIcon } from './baseIcon';

export const Facebook = () => (
  <BaseIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24" fill="none" width="24">
    <path
      d="M13.1397 23V13.4209H16.3829L16.8684 9.68781H13.1397V7.30407C13.1397 6.22386 13.4426 5.48687 15.0058 5.48687L17 5.48629V2.14751C16.655 2.10167 15.4712 2 14.0941 2C11.2196 2 9.25151 3.73962 9.25151 6.93499V9.68781H6V13.4209H9.25151V23H13.1397Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="white"
    />
  </BaseIcon>
);
